import React from "react";
import BackgroundImage from 'gatsby-background-image'
import { graphql, useStaticQuery } from 'gatsby';
import withStyles from "@material-ui/core/styles/withStyles";

function Votes({...props}) {
  const {
    className,
    imageUrl,
    children,
    style
  } = props;
  const data = useStaticQuery(
    graphql`
      query {
        desktop: file(relativePath: { eq: "votes.jpg" }) {
          childImageSharp {
            fluid(quality: 50, maxWidth: 960) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  // Set ImageData.
  const imageData = data.desktop.childImageSharp.fluid;

  return (
    <BackgroundImage 
    Tag="div"
    role="img"
    aria-label="Many vote buttons held in a person's hand."
    className={className}
    fluid={imageData}
    style={style}
    >
      {children}
    </BackgroundImage>
  )
};

const styles = {
  width: "100%",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover"
};

export default withStyles(styles)(Votes);